module.exports = __webpack_public_path__ + "static/media/3.49d70c16.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/gomel/3.JPG
// module id = 221
// module chunks = 0